import { COPY, STORAGE_LANG, type Lang, type LocaleCopy } from "./copy";

export function detectLang(): Lang {
  const stored = localStorage.getItem(STORAGE_LANG);
  if (stored === "en" || stored === "zh") return stored;
  return "zh";
}

function setText(sel: string, value: string): void {
  document.querySelectorAll<HTMLElement>(sel).forEach((el) => {
    el.textContent = value;
  });
}

function setHtml(sel: string, value: string): void {
  const el = document.querySelector<HTMLElement>(sel);
  if (el) el.innerHTML = value;
}

function renderServices(copy: LocaleCopy): void {
  const rail = document.getElementById("service-rail");
  if (!rail) return;
  rail.replaceChildren(
    ...copy.services.map((item, index) => {
      const card = document.createElement("article");
      card.className = "service-card";
      card.dataset.service = String(index);

      const idx = document.createElement("span");
      idx.className = "idx";
      idx.textContent = String(index + 1).padStart(2, "0");

      const h3 = document.createElement("h3");
      h3.textContent = item.title;

      const p = document.createElement("p");
      p.textContent = item.body;

      card.append(idx, h3, p);
      return card;
    }),
  );
}

function renderPolicy(copy: LocaleCopy): void {
  const root = document.getElementById("faq_accordion");
  if (!root) return;

  root.replaceChildren(
    ...copy.policy.map((section, index) => {
      const item = document.createElement("div");
      item.className = index === 0 ? "accordion-item is-open" : "accordion-item";

      const h3 = document.createElement("h3");
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "accordion-button";
      btn.setAttribute("aria-expanded", index === 0 ? "true" : "false");
      btn.textContent = section.title;
      h3.append(btn);

      const panel = document.createElement("div");
      panel.className = "accordion-panel";
      if (index !== 0) panel.hidden = true;

      const body = document.createElement("div");
      body.className = "accordion-body";
      body.innerHTML = section.html;
      panel.append(body);

      item.append(h3, panel);
      return item;
    }),
  );
}

export function applyLang(lang: Lang): void {
  const copy = COPY[lang];
  document.documentElement.lang = lang === "zh" ? "zh-CN" : "en";
  document.title = copy.title;

  document
    .querySelector('meta[name="description"]')
    ?.setAttribute("content", copy.description);
  document
    .querySelector('meta[property="og:title"]')
    ?.setAttribute("content", copy.title);
  document
    .querySelector('meta[property="og:description"]')
    ?.setAttribute("content", copy.description);
  document
    .querySelector('meta[property="og:locale"]')
    ?.setAttribute("content", lang === "zh" ? "zh_CN" : "en_US");

  setText("[data-i18n=brand]", copy.brand);
  setText("[data-i18n=skip]", copy.skipToContent);
  setText("[data-i18n=nav-home]", copy.navHome);
  setText("[data-i18n=nav-services]", copy.navServices);
  setText("[data-i18n=nav-policy]", copy.navPolicy);
  setText("[data-i18n=kicker]", copy.kicker);
  setHtml("[data-i18n=hero-title]", copy.heroTitleHtml);
  setText("[data-i18n=lead]", copy.lead);
  setText("[data-i18n=scroll-hint]", copy.scrollHint);
  setText("[data-i18n=services-title]", copy.servicesTitle);
  setText("[data-i18n=services-lead]", copy.servicesLead);
  setText("[data-i18n=policy-title]", copy.policyTitle);
  setText("[data-i18n=policy-lead]", copy.policyLead);
  setText("[data-i18n=status]", copy.footerStatus);
  setText("[data-i18n=notfound-title]", copy.notFoundTitle);
  setText("[data-i18n=notfound-body]", copy.notFoundBody);
  setText("[data-i18n=notfound-back]", copy.notFoundBack);

  const langBtn = document.getElementById("lang-toggle");
  if (langBtn) {
    langBtn.setAttribute("aria-label", copy.langAria);
    const ind = langBtn.querySelector("#lang-indicator");
    if (ind) ind.textContent = lang === "zh" ? "En" : "中";
  }

  const themeBtn = document.getElementById("theme-toggle");
  if (themeBtn) themeBtn.setAttribute("aria-label", copy.themeAria);

  renderServices(copy);
  renderPolicy(copy);

  localStorage.setItem(STORAGE_LANG, lang);
  document.dispatchEvent(new CustomEvent("boorhub:lang", { detail: { lang } }));
}

export function toggleLang(current: Lang): Lang {
  const next: Lang = current === "zh" ? "en" : "zh";
  applyLang(next);
  return next;
}
